import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function HotRecommend() {
  const hotComics = comics.filter((c) => c.isHot);
  const newComics = comics.filter((c) => c.isNew);

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-2">
              千万读者的选择，口碑爆棚的韩漫佳作
            </p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} variant="default" />
          ))}
        </div>

        <div className="mt-16">
          <div className="flex items-center justify-between mb-10">
            <div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
                最新上架
              </h2>
              <p className="text-sm md:text-base text-foreground-600 mt-2">
                刚刚更新的新鲜漫画，快来尝鲜
              </p>
            </div>
            <Link
              to="/category/romance"
              className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              查看全部 <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
            {newComics.map((comic) => (
              <ComicCard key={comic.id} comic={comic} variant="default" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}